module.exports = __webpack_public_path__ + "fonts/35d85034cc6efe254752721f40dae9f4-Roboto-Light.eot";